<template>
    <div>
        <v-error-messages :has-frontend-errors="validate.$error" class="stack-l">
            <li class="list-item" v-if="validate.type.$error">Rejection time must me selected</li>
            <li class="list-item" v-if="validate.message.$error">Rejection message is required</li>
        </v-error-messages>
        <v-select
            label="Rejection Reason"
            :options="rejectionOptions"
            v-model="type"
            @input="input"
            :validate="validate.type"
            class="stack-m"/>
        <r-input
            label="Rejection Message"
            :multiline="true"
            rows="2"
            placeholder="Reason to reject this document"
            v-model="message"
            :validate="validate.message"
            @input="input"/>
    </div>
</template>

<script>
    import _ from '@/common/helpers';
    import {vSelect, vErrorMessages} from '@/components/form';
    import KYCDocumentModel from '@/common/models/kyc-document-model';

    export default {
        name: 'rejection-form',
        components: {
            vSelect,
            vErrorMessages,
        },
        props: {
            value: Object,
            validate: Object,
        },
        data() {
            return {
                type: this.value.type,
                message: this.value.message,
            };
        },
        computed: {
            rejectionOptions() {
                const options = Object.values(KYCDocumentModel.RejectionTypes);
                return options.map(
                    value => ({label: _.unKebabCase(value), value}),
                );
            },
        },
        methods: {
            input() {
                this.$emit('input', {type: this.type, message: this.message});
            },
        },
    };
</script>
